import { useState } from 'react';

export const useSaveModal = () => {
    const [filterName, setFilterName] = useState<string>('');
    const isSaveDisabled = !filterName;

    return {
        isSaveDisabled,
        filterName,
        setFilterName,
    };
};
